/* scarlett-pdp-glow.js — per-product spotlight for the PDP "shadow box" gallery.
   Samples the hero image and sets --scH-glow (R,G,B) on .scH-pdp so the navy
   backdrop's spotlight takes the product's own hue (cherry-burst -> amber, blue
   synth -> blue). Uses a crossOrigin probe so the canvas isn't tainted (Shopify
   CDN sends ACAO). Greyscale/neutral products and ANY error fall back to brand
   blue. Pure progressive enhancement — the design looks right without it. */
(function () {
  var BLUE = '30, 91, 214';
  var lastSrc = '';

  function toVividRGB(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn, h = 0, s = 0;
    if (d) {
      s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);
      if (mx === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
    }
    s = Math.min(0.85, Math.max(0.55, s)); // keep it vivid
    l = Math.min(0.60, Math.max(0.48, l)); // mid lightness so it reads on navy
    function f(p, q, t) { if (t < 0) t += 1; if (t > 1) t -= 1; if (t < 1 / 6) return p + (q - p) * 6 * t; if (t < 1 / 2) return q; if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6; return p; }
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s, p = 2 * l - q;
    return [Math.round(f(p, q, h + 1 / 3) * 255), Math.round(f(p, q, h) * 255), Math.round(f(p, q, h - 1 / 3) * 255)].join(', ');
  }

  function setGlow() {
    var root = document.querySelector('.scH-pdp');
    if (!root) return;
    var img = root.querySelector('.product__media-item.is-active img') || root.querySelector('.product__media img');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src || src === lastSrc) return;
    lastSrc = src;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var n = 28, c = document.createElement('canvas'); c.width = n; c.height = n;
        var ctx = c.getContext('2d'); ctx.drawImage(probe, 0, 0, n, n);
        var data = ctx.getImageData(0, 0, n, n).data, r = 0, g = 0, b = 0, k = 0;
        for (var i = 0; i < data.length; i += 4) {
          var R = data[i], G = data[i + 1], B = data[i + 2];
          if (R > 235 && G > 235 && B > 235) continue;             // skip near-white background
          if (Math.max(R, G, B) - Math.min(R, G, B) < 28) continue; // skip greys / blacks
          r += R; g += G; b += B; k++;
        }
        root.style.setProperty('--scH-glow', k > n * n * 0.03 ? toVividRGB(r / k, g / k, b / k) : BLUE);
      } catch (e) { root.style.setProperty('--scH-glow', BLUE); }
    };
    probe.onerror = function () { root.style.setProperty('--scH-glow', BLUE); };
    probe.src = src;
  }

  function init() {
    setGlow();
    var root = document.querySelector('.scH-pdp');
    if (root && 'MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(setGlow, 60); })
        .observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
